import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertFormItem(component, type) {
  var properties = component.properties;
  var brick = type;
  var props = _objectSpread(_objectSpread({}, properties), {}, {
    themeVariant: "elevo"
  });
  switch (brick) {
    case "eo-search":
      props = _objectSpread(_objectSpread({}, props), {}, {
        trim: true
      });
      break;
    case "eo-number-input":
      brick = "eo-input";
      props = _objectSpread({
        type: "number"
      }, props);
      break;
  }
  return {
    brick: brick,
    properties: props
  };
}
//# sourceMappingURL=convertFormItem.js.map